import { render } from "./Commercialista.vue?vue&type=template&id=45af0a46&scoped=true"
import script from "./Commercialista.vue?vue&type=script&lang=js"
export * from "./Commercialista.vue?vue&type=script&lang=js"

import "./Commercialista.vue?vue&type=style&index=0&id=45af0a46&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45af0a46"]])

export default __exports__